import React, { useState, useRef, useEffect } from "react";
import styles from "./Input.module.scss";
import dropdownicon from "../../../assets/Imagess/dropdownicon.svg";
import CheckBox from "./CheckBox";

const CustomizedSelectwithCheckbox = ({
  options,
  onChange,
  value,
  name,
  placeholder,
  icon,
  label,
  errors,
  touched,
  required,
  scroll,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [selectedValues, setSelectedValues] = useState(value || []);
  const dropdownRef = useRef(null);

  const handleCheckboxClick = (e, option) => {
    setChecked(
      selectedValues?.some(
        (selectedOption) => selectedOption.value === option.value
      )
    );
    e.stopPropagation();
  };

  const toggleCheckUser = (option) => {
    const updatedValues = selectedValues.some(
      (selectedOption) => selectedOption.value === option.value
    )
      ? selectedValues.filter(
          (selectedOption) => selectedOption.value !== option.value
        )
      : [...selectedValues, option];

    setChecked(
      updatedValues.some(
        (selectedOption) => selectedOption.value === option.value
      )
    );
    setSelectedValues(updatedValues);
    onChange(name, updatedValues);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.selectContainer} ref={dropdownRef}>
      {label ? (
        <label>
          {label} {required && <span className={styles.required}>*</span>}
        </label>
      ) : (
        ""
      )}
      <div
        className={`${errors && touched ? styles.error : styles.selectInput} ${
          isOpen ? styles.open : ""
        }`}
        style={{
          overflow: scroll ? "hidden" : "",
          borderRadius: scroll && selectedValues?.length > 0 ? "20px" : "",
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedValues?.length > 0 ? (
          <span
            className={styles.selectedValues}
            style={{
              overflow: scroll ? "scroll" : "",
              maxHeight: scroll ? "53px" : "",
              paddingLeft: scroll ? "10px" : "",
            }}
          >
            {selectedValues
              .map((item) => {
                return item.text;
              })
              .join(", ")}
          </span>
        ) : (
          <div className={styles.selectedValueicont}>
            <span className={styles.placeholder}>
              {icon && <img src={icon} alt='icon' />}
              {placeholder}
            </span>{" "}
            <img
              src={dropdownicon}
              alt='dropdown icon'
              className={styles.arrowIcon}
            />
          </div>
        )}
      </div>
      {isOpen && (
        <div className={styles.dropdown}>
          {options.map((option, index) => (
            <div
              key={index}
              className={
                index % 2 === 0 ? styles.dropdownItem : styles.dropdownItemOdd
              }
            >
              <div
                className={styles.dropdowncontainer}
                onClick={(e) => handleCheckboxClick(e, option)}
              >
                <CheckBox
                  value={selectedValues
                    ?.map((item) => {
                      return item.value;
                    })
                    .includes(option.value)}
                  onChange={() => toggleCheckUser(option)}
                />
                {option.text}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomizedSelectwithCheckbox;
